import { Icon, IconProps } from '@chakra-ui/react'

export default function ArrowRepeatRotateIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        d="M15 6H9a6 6 0 00-6 6c0 1.912.897 3.611 2.29 4.71M9 18h6a6 6 0 006-6 5.985 5.985 0 00-2.29-4.71"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 15.5L9 18l2.5 2.5M12.5 8.5L15 6l-2.5-2.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
